import { useQuery } from '@w/react-query'
import { useRouterContext } from '../router/flashcards-fe.router-bindings'
import { preparedMediaOptions } from './prepared-media-options'
import { isStoredMediaPath } from './media-paths'

export function usePreparedMedia(paths: readonly string[]) {
  const ctx = useRouterContext()
  const bucket = ctx.bucket
  const query = useQuery({
    ...preparedMediaOptions(bucket, paths),
    enabled: paths.length > 0,
  }, ctx.queryClient)
  const pending = paths.length > 0 && (query.isPending || query.isFetching)
  return {
    pending,
    retry: () => { void query.refetch() },
    resolve: (path: string) => {
      if (!isStoredMediaPath(path)) return path
      if (query.data?.some(file => file.path === path && file.status === 'unavailable')) return ''
      return bucket.getUrl(path)
    },
  }
}
